import {landscape, portrait} from '../../../config/screen';

export function isDeviceMobile(window) {
    return window && (window.innerWidth <= landscape && window.matchMedia("(orientation: landscape)").matches ||
        window.innerWidth <= portrait && window.matchMedia("(orientation: portrait)").matches);
}

export function getDeviceOrientation(window) {
    return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
}